var React = require('react');

function GasPump (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M256 0H96a64.06 64.06 0 0 0-64 64v384h288V64a64.06 64.06 0 0 0-64-64zm0 192H96V64h160z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M256 64H96v128h160zm80 384H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm157.2-340.7l-81-81a16.06 16.06 0 0 0-22.6 0l-11.3 11.3a16.06 16.06 0 0 0 0 22.6L416 97.9V160a55.9 55.9 0 0 0 48 55.2V376a24 24 0 0 1-48 0v-32a88 88 0 0 0-88-88h-8v48h8a40 40 0 0 1 40 40v27.8c0 37.7 27 72 64.5 75.9A72.2 72.2 0 0 0 512 376V152.6a64.15 64.15 0 0 0-18.8-45.3z","className":"fa-primary","key":2})]);
}

GasPump.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = GasPump;

GasPump.default = GasPump;
